module.exports = __webpack_public_path__ + "img/Frame4298.daf27fdd.jpg";